﻿export class PdfUrlBuilder {
  build(fileUrl: string) {
    return fileUrl;
  }
}